module.exports = __webpack_public_path__ + "img/空白（动静态文字）.9bee68b7.jpg";